var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 61,
    viewBox: "0 0 211 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.185 61H7.81481C3.51862 61 0 57.5668 0 53.375V7.625C0 3.43316 3.51862 5.72205e-06 7.81481 5.72205e-06H203.185C207.481 5.72205e-06 211 3.43316 211 7.625V53.375C211 57.5668 207.481 61 203.185 61Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.185 1.22191C206.803 1.22191 209.748 4.09463 209.748 7.625V53.375C209.748 56.9054 206.803 59.7781 203.185 59.7781H7.81481C4.19656 59.7781 1.25232 56.9054 1.25232 53.375V7.625C1.25232 4.09463 4.19656 1.22191 7.81481 1.22191H203.185ZM203.185 5.72205e-06H7.81481C3.51862 5.72205e-06 0 3.43316 0 7.625V53.375C0 57.5668 3.51862 61 7.81481 61H203.185C207.481 61 211 57.5668 211 53.375V7.625C211 3.43316 207.481 5.72205e-06 203.185 5.72205e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3093 11.4969C15.8502 11.9658 15.5845 12.6959 15.5845 13.6414V47.3668C15.5845 48.3123 15.8502 49.0424 16.3093 49.5113L16.4226 49.6143L35.7916 30.7233V30.2773L16.4226 11.3863L16.3093 11.4969Z",
    fill: "url(#paint0_linear_220_18507)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2407 37.0234L35.7915 30.7233V30.2772L42.2485 23.9771L42.3931 24.059L50.0399 28.3043C52.2221 29.509 52.2221 31.4915 50.0399 32.7039L42.3931 36.9415L42.2407 37.0234Z",
    fill: "url(#paint1_linear_220_18507)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.393 36.941L35.7914 30.4998L16.3091 49.5108C17.0339 50.2543 18.2159 50.3439 19.56 49.6004L42.393 36.941Z",
    fill: "url(#paint2_linear_220_18507)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.393 24.0588L19.56 11.3994C18.2159 10.6636 17.0339 10.7532 16.3091 11.4966L35.7914 30.5L42.393 24.0588Z",
    fill: "url(#paint3_linear_220_18507)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1117 15.6223C74.1117 16.8957 73.721 17.9155 72.9512 18.6761C72.0662 19.5778 70.9135 20.0315 69.501 20.0315C68.1509 20.0315 66.9983 19.5702 66.0527 18.6609C65.1051 17.7383 64.6323 16.6059 64.6323 15.2506C64.6323 13.8953 65.1051 12.7629 66.0527 11.8479C66.9983 10.931 68.1509 10.4697 69.501 10.4697C70.173 10.4697 70.8138 10.6051 71.4253 10.8567C72.0349 11.1102 72.5311 11.4534 72.8906 11.8765L72.074 12.681C71.4468 11.9585 70.5931 11.602 69.501 11.602C68.5163 11.602 67.6625 11.9375 66.9377 12.6143C66.2207 13.2929 65.8612 14.1717 65.8612 15.2506C65.8612 16.3295 66.2207 17.2159 66.9377 17.8946C67.6625 18.5637 68.5163 18.9068 69.501 18.9068C70.5462 18.9068 71.4254 18.5637 72.1189 17.8869C72.5761 17.439 72.8359 16.8214 72.9043 16.0322H69.501V14.9304H74.0414C74.0961 15.1686 74.1117 15.3993 74.1117 15.6223Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3151 11.8015H77.0502V14.699H80.895V15.8008H77.0502V18.6983H81.3151V19.8211H75.8428V10.6787H81.3151V11.8015Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3986 19.8211H85.1912V11.8015H82.5752V10.6787H89.0166V11.8015H86.3986V19.8211Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6782 19.8211V10.6787H94.8837V19.8211H93.6782Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.227 19.8211H99.0291V11.8015H96.4033V10.6787H102.852V11.8015H100.227V19.8211Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.048 18.6456C114.124 19.5702 112.979 20.0315 111.613 20.0315C110.24 20.0315 109.095 19.5702 108.171 18.6456C107.249 17.723 106.79 16.5907 106.79 15.2506C106.79 13.9105 107.249 12.7782 108.171 11.8556C109.095 10.931 110.24 10.4697 111.613 10.4697C112.971 10.4697 114.116 10.931 115.04 11.8632C115.97 12.7934 116.429 13.9181 116.429 15.2506C116.429 16.5907 115.97 17.723 115.048 18.6456ZM109.064 17.8793C109.759 18.5637 110.605 18.9068 111.613 18.9068C112.614 18.9068 113.467 18.5637 114.155 17.8793C114.849 17.195 115.2 16.3162 115.2 15.2506C115.2 14.185 114.849 13.3062 114.155 12.6219C113.467 11.9375 112.614 11.5944 111.613 11.5944C110.605 11.5944 109.759 11.9375 109.064 12.6219C108.37 13.3062 108.018 14.185 108.018 15.2506C108.018 16.3162 108.37 17.195 109.064 17.8793Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.123 19.8211V10.6787H119.588L124.144 17.789H124.197L124.144 16.0315V10.6787H125.349V19.8211H124.091L119.32 12.36H119.267L119.32 14.1252V19.8211H118.123Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.493 33.1722C102.822 33.1722 99.8226 35.8981 99.8226 39.6591C99.8226 43.3897 102.822 46.1442 106.493 46.1442C110.171 46.1442 113.17 43.3897 113.17 39.6591C113.17 35.8981 110.171 33.1722 106.493 33.1722ZM106.493 43.5898C104.478 43.5898 102.745 41.9676 102.745 39.6591C102.745 37.3202 104.478 35.7265 106.493 35.7265C108.507 35.7265 110.248 37.3202 110.248 39.6591C110.248 41.9676 108.507 43.5898 106.493 43.5898ZM91.9394 33.1722C88.2605 33.1722 85.2694 35.8981 85.2694 39.6591C85.2694 43.3897 88.2605 46.1442 91.9394 46.1442C95.6162 46.1442 98.6093 43.3897 98.6093 39.6591C98.6093 35.8981 95.6162 33.1722 91.9394 33.1722ZM91.9394 43.5898C89.9232 43.5898 88.1844 41.9676 88.1844 39.6591C88.1844 37.3202 89.9232 35.7265 91.9394 35.7265C93.9536 35.7265 95.6866 37.3202 95.6866 39.6591C95.6866 41.9676 93.9536 43.5898 91.9394 43.5898ZM74.6218 35.1604V37.9168H81.3679C81.1706 39.4571 80.6431 40.5894 79.8342 41.3786C78.8496 42.3317 77.3159 43.3896 74.6218 43.3896C70.4701 43.3896 67.2192 40.1204 67.2192 36.0697C67.2192 32.0189 70.4701 28.7497 74.6218 28.7497C76.8666 28.7497 78.4999 29.6056 79.7053 30.715L81.6961 28.7725C80.0101 27.2018 77.7672 25.9951 74.6218 25.9951C68.9287 25.9951 64.144 30.5148 64.144 36.0697C64.144 41.6245 68.9287 46.1442 74.6218 46.1442C77.6988 46.1442 80.0101 45.1606 81.827 43.3153C83.6889 41.4987 84.2691 38.9443 84.2691 36.8817C84.2691 36.2412 84.2144 35.6522 84.1168 35.1604H74.6218ZM145.436 37.2973C144.887 35.8466 143.193 33.1722 139.743 33.1722C136.324 33.1722 133.477 35.8009 133.477 39.6591C133.477 43.2924 136.294 46.1442 140.071 46.1442C143.124 46.1442 144.887 44.3275 145.612 43.2696L143.345 41.796C142.589 42.875 141.56 43.5898 140.071 43.5898C138.592 43.5898 137.531 42.9283 136.851 41.6245L145.742 38.035L145.436 37.2973ZM136.371 39.4571C136.294 36.9561 138.361 35.6751 139.842 35.6751C141.003 35.6751 141.987 36.2412 142.316 37.0514L136.371 39.4571ZM129.144 45.7496H132.066V26.6871H129.144V45.7496ZM124.357 34.6171H124.259C123.603 33.8584 122.351 33.1722 120.764 33.1722C117.435 33.1722 114.391 36.0239 114.391 39.6801C114.391 43.3153 117.435 46.1442 120.764 46.1442C122.351 46.1442 123.603 45.4522 124.259 44.6707H124.357V45.6009C124.357 48.0809 122.999 49.4134 120.809 49.4134C119.024 49.4134 117.916 48.1553 117.459 47.0973L114.917 48.1324C115.65 49.8518 117.59 51.9678 120.809 51.9678C124.236 51.9678 127.128 50.0005 127.128 45.2139V33.5667H124.357V34.6171ZM121.014 43.5898C119 43.5898 117.314 41.9447 117.314 39.6801C117.314 37.3945 119 35.7265 121.014 35.7265C122.999 35.7265 124.564 37.3945 124.564 39.6801C124.564 41.9447 122.999 43.5898 121.014 43.5898ZM159.119 26.6871H152.129V45.7496H155.044V38.5268H159.119C162.357 38.5268 165.531 36.2412 165.531 32.606C165.531 28.9727 162.349 26.6871 159.119 26.6871ZM159.196 35.8752H155.044V29.3387H159.196C161.372 29.3387 162.615 31.102 162.615 32.606C162.615 34.0814 161.372 35.8752 159.196 35.8752ZM177.215 33.1359C175.109 33.1359 172.918 34.0433 172.018 36.0544L174.604 37.1124C175.161 36.0544 176.185 35.7113 177.267 35.7113C178.78 35.7113 180.313 36.5977 180.337 38.1627V38.3629C179.809 38.0655 178.68 37.6252 177.291 37.6252C174.505 37.6252 171.666 39.1216 171.666 41.9142C171.666 44.4686 173.948 46.1137 176.513 46.1137C178.475 46.1137 179.557 45.2502 180.237 44.2456H180.337V45.7191H183.152V38.4067C183.152 35.0269 180.565 33.1359 177.215 33.1359ZM176.863 43.5822C175.91 43.5822 174.581 43.1209 174.581 41.9676C174.581 40.4922 176.238 39.926 177.672 39.926C178.955 39.926 179.557 40.2024 180.337 40.5665C180.108 42.3317 178.551 43.5822 176.863 43.5822ZM193.409 33.5534L190.058 41.817H189.959L186.495 33.5534H183.351L188.556 45.1015L185.586 51.5274H188.632L196.652 33.5534H193.409ZM167.133 45.7496H170.056V26.6871H167.133V45.7496Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_18507",
    x1: 34.0719,
    y1: 47.718,
    x2: 8.48646,
    y2: 21.4957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_220_18507",
    x1: 52.8816,
    y1: 30.4981,
    x2: 15.0627,
    y2: 30.4981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_220_18507",
    x1: 38.8032,
    y1: 26.9983,
    x2: 4.10733,
    y2: -8.56137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_220_18507",
    x1: 11.405,
    y1: 60.7313,
    x2: 26.8983,
    y2: 44.8525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/Google Play.d2819026dbd59f640cc157f085756fdb.svg";
export { ForwardRef as ReactComponent };